'use strict';

var Backbone = require('backbone');
var AgentModel = require('../models/agentModel');

class AgentsCollection extends Backbone.Collection.extend({

  model: AgentModel

}) {

  comparator(model) {
    // Sort the agents as a string so that the ones available for chat are listed first
    let stringSort = (model.get('is_video_capable') ? '0' : '1') +
      (model.get('is_audio_capable') ? '0' : '1') +
      (model.get('is_text_capable') ? '0' : '1') +
      (model.get('isVideoEngineer') ? '0' : '1') +
      (model.get('index') || 'X');
    return stringSort;
  }

}

module.exports = AgentsCollection;



// WEBPACK FOOTER //
// ./assets/components/VideoDesk/collections/agentsCollection.js